import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    background: '#fee3e7',
    overflow: 'hidden',
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  title: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: 32,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 30,
      },
    },
  },
  sliderWrapper: {
    width: '100%',
    paddingBlock: 40,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.down('400')]: {
      gap: 6,
    },
  },
  sliderContainer: {
    display: 'flex',
  },
  card: {
    width: 'auto',
    minHeight: 280,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow:
      '0px 0px 4px rgba(0, 0, 0, 0.04), 2px 1px 25px rgba(0, 0, 0, 0.08)',
    paddingBlock: 32,
    paddingInline: 36,
    [theme.breakpoints.down('md')]: {
      paddingInline: 28,
    },
    [theme.breakpoints.down('400')]: {
      width: 'auto',
    },
  },
  nameWrapper: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    '& .MuiAvatar-root': {
      width: 54,
      height: 54,
    },
  },
  name: {
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  review: {
    '& .MuiTypography-root': {
      paddingBlockStart: 20,
      paddingBlockEnd: 8,
      [theme.breakpoints.down('md')]: {
        fontSize: 15,
      },
    },
  },
  icon: {
    '& .MuiIconButton-root': {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#fff',
        color: theme.palette.custom.main,
      },
    },
  },
}))

export default useStyles
